import BadgeIcon from "../../../Icons/BadgeIcon";

function MultipleChoice({ entryjson, inputs, setInputs, saveMemberEntry }) {
  //const { showToast } = useToast();

  const entrydet = JSON.parse(entryjson.entry);
  const entrychoice = entrydet?.choices || "";

  const choices = entrychoice
    .split(",")
    .filter((choices) => choices.trim() !== "");

  const handleChange = (e) => {
    const { name, value, checked } = e.target;

    setInputs((prevInputs) => {
      let updatedValue = [];

      if (checked) {
        // If the checkbox is checked, add the value to the array for that name
        if (prevInputs[name]) {
          updatedValue = [...prevInputs[name], value];
        } else {
          updatedValue = [value];
        }
      } else {
        // If the checkbox is unchecked, remove the value from the array
        if (prevInputs[name]) {
          updatedValue = prevInputs[name].filter((val) => val !== value);
        } else {
          updatedValue = [];
        }
      }

      return {
        ...prevInputs,
        [name]: updatedValue,
      };
    });

    console.log(JSON.stringify(inputs, null, 2)); // Log the updated inputs as JSON
  };

  const saveEntry = () => {
    saveMemberEntry();
  };

  return (
    <div>
      <div className="cursor-default">
        <div className="flex flex-col md:flex-row justify-between">
          <div className="md:w-[440px]">
            <h4 className="font-medium text-[15px] leading-[22px] text-black opacity-100 mb-1">
              {entryjson?.headline}
            </h4>
            <p className="text-left font-normal text-[14px] leading-[20px] text-black opacity-100 sm:text-[12px] sm:leading-[20px] mb-1">
              {entrydet?.description}
            </p>
          </div>
          <div className="hidden min-[426px]:block">
            <span class="earn_points_btn bg-white text-[#0274F7] text-sm font-medium inline-flex items-center px-3 py-1 rounded-md border border-[#0274F7]">
              <BadgeIcon width={20} height={20} className={"mr-1"} />
              {entrydet?.worth} <span className="text-sm ml-1">Points</span>
            </span>
          </div>
        </div>
        <div className="mt-2">
          {choices.length > 0 ? (
            choices.map((choices_det, index) => (
              <div key={index} className="flex items-center mb-2">
                <input
                  type="checkbox"
                  id={`choices-${index}`}
                  name="entry_val"
                  value={choices_det.trim()}
                  onChange={handleChange}
                  className="h-4 w-4 cursor-pointer radio-primary rounded border-gray-300 text-[#0274F7] focus:ring-[#0274F7] mr-2"
                />
                <label
                  htmlFor={`choices-${index}`}
                  className="font-normal text-[12px] md:text-[15px] leading-[22px] text-black opacity-100"
                >
                  {choices_det.trim()}
                </label>
              </div>
            ))
          ) : (
            <div>No data Found </div>
          )}
        </div>
        <div className="flex items-center justify-between">
          <div className="pt-2">
            <button
              disabled={!inputs?.entry_val?.length}
              onClick={() => saveEntry()}
              className={`primary_btn_bg primary_btn_bg bg-[#0274F7] text-white px-3 py-2 rounded-md text-[13px] leading-[15px] text-left border border-[#0274F7] ${
                !inputs?.entry_val?.length
                  ? "opacity-50 cursor-not-allowed"
                  : " hover:bg-white hover:text-[#0274F7] hover:border-[#0274F7]"
              }`}
            >
              Earn Points
            </button>
          </div>
          <div className="pt-2">
            <span class="earn_points_btn bg-white ml-2 text-[#0274F7] text-sm font-medium inline-flex items-center px-3 py-1 rounded-md border border-[#0274F7] sm:hidden">
              <BadgeIcon width={20} height={20} className={"mr-1"} />
              {entrydet?.worth} <span className="text-sm ml-1">Points</span>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MultipleChoice;
